module.exports = __webpack_public_path__ + "img/twitter.5f45ce78.svg";